import { FILE_SIZE_LIMIT, SUPPORTED_FORMATS } from '@/services/image';
import { Status } from '@/utils/constants';
import { ERROR_MESSAGE_FIELD } from '@/utils/constants/messages';
import moment from 'moment';
import * as yup from 'yup';

export const formSchemaFn = (isUpdate: boolean, isDisabled?: boolean) => {
  return yup.object().shape({
    appName: yup
      .string()
      .trim()
      .required('投稿者名は未入力です。')
      .max(40, '投稿者名は40文字以内で入力してください。'),
    title: yup
      .string()
      .trim()
      .required('タイトルは未入力です。')
      .max(100, 'タイトルは100文字以内で入力してください。'),
    type: yup
      .mixed<'NOUNOW' | 'COGEVO'>()
      .oneOf(['NOUNOW', 'COGEVO'])
      .required('遷移先は未入力です。'),
    iconAttachment: yup
      .mixed()
      .when(['iconAttachments', 'icon'], ([iconAttachments, icon], schema) => {
        if (icon && (!iconAttachments || !iconAttachments?.fileList?.length)) {
          return schema;
        }
        if (!iconAttachments || !iconAttachments?.fileList?.length) {
          return schema.required(
            ERROR_MESSAGE_FIELD.UPLOAD_MISSING_FILE('アイコン画像'),
          );
        }
        return schema
          .test('fileSize', '画像のサイズは10MBを超えています。', (_) => {
            return iconAttachments?.fileList[0]?.size <= FILE_SIZE_LIMIT;
          })
          .test(
            'fileType',
            '画像は .jpg、.png、.jpeg 形式ではありません。',
            (_) => {
              return SUPPORTED_FORMATS.includes(
                iconAttachments?.fileList[0]?.type,
              );
            },
          );
      }),
    coverAttachment: yup
      .mixed()
      .when(
        ['coverAttachments', 'cover'],
        ([coverAttachments, cover], schema) => {
          if (
            cover &&
            (!coverAttachments || !coverAttachments?.fileList?.length)
          ) {
            return schema;
          }
          if (!coverAttachments || !coverAttachments?.fileList?.length) {
            return schema.required(
              ERROR_MESSAGE_FIELD.UPLOAD_MISSING_FILE('カバー画像'),
            );
          }
          return schema
            .test('fileSize', '画像のサイズは10MBを超えています。', (_) => {
              return coverAttachments?.fileList[0]?.size <= FILE_SIZE_LIMIT;
            })
            .test(
              'fileType',
              '画像は .jpg、.png、.jpeg 形式ではありません。',
              (_) => {
                return SUPPORTED_FORMATS.includes(
                  coverAttachments?.fileList[0]?.type,
                );
              },
            );
        },
      ),

    status: yup
      .number()
      .oneOf([0, 1], 'ステータスが不正です。')
      .required('ステータスは必須です。')
      .typeError('ステータスが不正です。'),
    publicAt: yup
      .date()
      .required('公開日時を選択してください。')
      .when(['status', 'prevStatus'], ([status, prevStatus], schema) => {
        if (status !== Status.PUBLIC) return schema;
        return schema.min(
          moment().add(1, 'minute').startOf('minute').toDate(),
          isUpdate
            ? '公開日時が過去の日時なので、ゲーム紹介を更新できませんでした。'
            : '公開日時が過去の日時なので、ゲーム紹介を作成できませんでした。',
        );
      }),
    publicEndAt: yup
      .date()
      .nullable()
      .typeError('公開終了日時は有効な日付である必要があります。')
      .test(
        'publicEndAt-after-publicAt',
        '公開終了日時は公開日時より後にしてください。',
        function (value) {
          const { publicAt } = this.parent;
          if (!value || !publicAt) return true;
          return moment(value).isAfter(moment(publicAt));
        },
      ),
  });
};
